//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  name: 'SidebarLogo',
  props: {
    collapse: {
      type: Boolean,
      required: true
    }
  },
  data: function data() {
    return {
      title: 'Carlcare Web',
      logo: 'https://public.carlcare.com/public/02756a7abe46465cd91e1384e85e18ff.png'
    };
  }
};